import React from "react";
import { ReactComponent as Remove } from "../Global Icons/CancelButton.svg";

const ImageShowerModalGlobal = ({
  file,
  state,
  setState,
  keyField,
  multiple = false,
}) => {
  return state[keyField] ? (
    <div className="border-15 border-1-grey upload-image-shower">
      <img className="" src={file} alt="" />
      <div
        onClick={() => {
          setState((prevData) => ({ ...prevData, [keyField]: "" }));
        }}
      >
        <Remove />
      </div>
    </div>
  ) : null;
};

export default ImageShowerModalGlobal;
